export type RoomLayoutMode = "desktop" | "mobile-portrait" | "mobile-landscape";

export function getRoomLayoutMode(width: number, height: number): RoomLayoutMode {
  if (width >= 1024) return "desktop";
  return height > width ? "mobile-portrait" : "mobile-landscape";
}

export function getSceneAvatarDimensions(dimensions: { width: number; height: number }) {
  const isPortraitScene = dimensions.height > dimensions.width;

  if (isPortraitScene && dimensions.width < 1024) {
    return { width: 108, height: 144 };
  }

  if (dimensions.width < 768 || dimensions.height < 600) {
    return { width: 132, height: 176 };
  }

  return { width: 234, height: 312 };
}

export function getSceneBackgroundStyle(layoutMode: RoomLayoutMode): {
  backgroundSize: string;
  backgroundPosition: string;
  backgroundRepeat?: string;
  backgroundColor?: string;
} {
  if (layoutMode === "mobile-portrait") {
    return {
      backgroundSize: "contain",
      backgroundPosition: "center center",
      backgroundRepeat: "no-repeat",
      backgroundColor: "#dcd4c8",
    };
  }

  return {
    backgroundSize: "cover",
    backgroundPosition: "center center",
  };
}
